import { QuickbooksQueryField, QuickbooksConnectionStatus } from '@common/neo.tax';

import { LocalStorageKey } from '../enums';
import { useUrlQueryParam } from './useUrlQueryParam';

export const useLinkAccountRedirect = (): void => {
  const accountingParamValue = useUrlQueryParam(QuickbooksQueryField.CONNECTED_STATUS);
  const payrollParamValue = useUrlQueryParam('connected_payroll');

  if (accountingParamValue) {
    const failedToConnectAccounting = accountingParamValue === QuickbooksConnectionStatus.FAILED;
    if (failedToConnectAccounting) {
      localStorage.setItem(LocalStorageKey.SESSION_CONNECTED_ACCOUNTING, QuickbooksConnectionStatus.FAILED);
    } else {
      localStorage.removeItem(LocalStorageKey.SESSION_CONNECTED_ACCOUNTING);
    }
    window.close();
  } else if (payrollParamValue) {
    const failedToConnectPayroll = payrollParamValue === 'failed';
    if (failedToConnectPayroll) {
      localStorage.setItem(LocalStorageKey.SESSION_CONNECTED_PAYROLL, 'failed');
    } else {
      localStorage.removeItem(LocalStorageKey.SESSION_CONNECTED_PAYROLL);
    }
    window.close();
  }
};
